import React from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { LinkIcon, Link2Icon, CornerDownRightIcon, CopyIcon, TypeIcon, FileTextIcon, AlignLeftIcon, Heading1Icon, Heading2Icon, ImageIcon, ImageOffIcon, CodeIcon } from 'lucide-react';
type CircleProgressProps = {
  percentage: number;
  label: string;
  colorClass: string;
};
const CircleProgress: React.FC<CircleProgressProps> = ({
  percentage,
  label,
  colorClass
}) => {
  const radius = 36;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - percentage / 100 * circumference;
  return <div className={colorClass} data-id="element-27">
      <div className="flex flex-col items-center glass-card p-3 sm:p-6" data-id="element-28">
        <div className="relative w-16 h-16 sm:w-24 sm:h-24 flex items-center justify-center mb-2 sm:mb-4" data-id="element-29">
          <svg className="w-full h-full transform -rotate-90" viewBox="0 0 96 96" data-id="element-30">
            <circle cx="48" cy="48" r={radius} className="stroke-slate-200 fill-none" strokeWidth="8" data-id="element-31" />
            <circle cx="48" cy="48" r={radius} className={`fill-none ${colorClass} transition-all duration-1000 ease-out`} strokeWidth="8" strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round" data-id="element-32" />
          </svg>
          <span className="absolute text-lg sm:text-2xl font-heading font-bold text-slate-900" data-id="element-33">
            {percentage}
          </span>
        </div>
        <span className="text-[10px] sm:text-sm font-semibold text-slate-600 text-center uppercase tracking-wider" data-id="element-34">
          {label}
        </span>
      </div>
    </div>;
};
const IssueItem = ({
  icon: Icon,
  label
}: {
  icon: any;
  label: string;
}) => <div className="flex items-center gap-2 sm:gap-3 p-2 sm:p-3 rounded-lg bg-slate-50 border border-slate-100" data-id="element-35">
    <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-md bg-red-500/10 flex items-center justify-center shrink-0" data-id="element-36">
      <Icon className="w-3 h-3 sm:w-4 sm:h-4 text-red-500" data-id="element-37" />
    </div>
    <span className="text-xs sm:text-sm text-slate-700 font-medium" data-id="element-38">
      {label}
    </span>

    <div className="ml-auto w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.4)] shrink-0" data-id="element-39" />
  </div>;
export function AuditScorecard() {
  return <>
      <SlideLayout data-id="element-40">
        <div className="mb-6 sm:mb-10" data-id="element-41">
          <div className="w-12 h-1 bg-gold-500 mb-4 sm:mb-6 rounded-full" data-id="element-42" />
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-43">
            Website Audit Scorecard
          </h2>
          <p className="text-sm sm:text-xl text-slate-500" data-id="element-44">
            Current technical performance and identified SEO roadblocks.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-6 mb-6 sm:mb-12" data-id="element-45">
          <CircleProgress percentage={55} label="Desktop Speed" colorClass="stroke-orange-500" data-id="element-46" />
          <CircleProgress percentage={59} label="Mobile Speed" colorClass="stroke-orange-500" data-id="element-47" />
          <CircleProgress percentage={43} label="Domain Authority" colorClass="stroke-yellow-500" data-id="element-48" />
          <CircleProgress percentage={79} label="Website Health" colorClass="stroke-green-500" data-id="element-49" />
        </div>

        <div className="glass-card p-4 sm:p-8" data-id="element-50">
          <h3 className="text-base sm:text-lg font-bold text-slate-900 mb-4 sm:mb-6 flex items-center gap-2" data-id="element-51">
            <span className="w-2 h-5 sm:h-6 bg-red-500 rounded-full inline-block" data-id="element-52" />
            Technical Issues Identified
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-4" data-id="element-53">
            <IssueItem icon={LinkIcon} label="External 4XX Pages" data-id="element-54" />
            <IssueItem icon={Link2Icon} label="Internal 4XX Pages" data-id="element-55" />
            <IssueItem icon={CornerDownRightIcon} label="Internal Redirects" data-id="element-56" />
            <IssueItem icon={CopyIcon} label="Meta Title Duplication" data-id="element-57" />
            <IssueItem icon={TypeIcon} label="Long Meta Titles" data-id="element-58" />
            <IssueItem icon={FileTextIcon} label="Missing Meta Descriptions" data-id="element-59" />
            <IssueItem icon={AlignLeftIcon} label="Long Meta Descriptions" data-id="element-60" />
            <IssueItem icon={Heading1Icon} label="Missing H1" data-id="element-61" />
            <IssueItem icon={Heading1Icon} label="Multiple H1 Headings" data-id="element-62" />
            <IssueItem icon={Heading2Icon} label="Missing H2" data-id="element-63" />
            <IssueItem icon={ImageIcon} label="Images Over 100KB" data-id="element-64" />
            <IssueItem icon={ImageOffIcon} label="Missing Alt Text" data-id="element-65" />
            <IssueItem icon={CodeIcon} label="Missing Schema Markup" data-id="element-66" />
          </div>
        </div>
      </SlideLayout>
    </>;
}